/* eslint-disable */
import React, { useEffect, useRef } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { Outlet } from 'react-router-dom'
import { BlankLayout } from 'components'
import { useNavigate } from 'react-router-dom'
import appConfig from 'config/app-config'

export const RequireAuth: React.FC = () => {
  const { oktaAuth, authState } = useOktaAuth()
  const navigate = useNavigate()
  const silentAuthAttempted = useRef(false)

  useEffect(() => {
    async function trySilentAuth() {
      try {
        const response = await oktaAuth.token.getWithoutPrompt()
        oktaAuth.tokenManager.setTokens(response.tokens)
        console.log('Silent authentication successful, tokens obtained without prompt.', response)
      } catch {
        const originalUri = toRelativeUrl(window.location.href, window.location.origin)
        oktaAuth.setOriginalUri(originalUri)
        navigate(appConfig.isMultiLogin ? '/multi-login' : '/login')
      }
    }

    if (!authState) {
      return
    }
    if (!authState.isAuthenticated && !silentAuthAttempted.current) {
      silentAuthAttempted.current = true
      trySilentAuth()
    }

  }, [oktaAuth, !!authState, authState?.isAuthenticated])

  if (!authState || !authState?.isAuthenticated) {
    return <BlankLayout />
  }

  return <Outlet />
}
